import React from 'react';
import ToastBase from './ToastBase';

import TToast from './@types/TToast';
import { FeedbackSignals } from '../../types/TEFeedbackSignal';

const Success: React.FC<TToast> = ({ children, icon, ...rest }) => (
  <ToastBase signal={FeedbackSignals.Success} icon={icon} {...rest}>
    {children}
  </ToastBase>
);

Success.displayName = 'SuccessToast';

export default Success;
